import React, {
  useRef,
  useState,
  useEffect,
  useMemo,
  type FC,
  type CSSProperties,
  useCallback,
} from 'react'
import styles from './ProgressBar.scss'

const ONE_SECOND = 1000
const MIN_TIME = 1

export type ProgressBarProps = {
  userRestart: boolean
  userStop: boolean
  message1: string
  message2: string
  userRestartProgress: () => void
  timeOver: () => void
  maxTime: number
}

export const ProgressBar: FC<ProgressBarProps> = (props) => {
  const {
    userRestart,
    userStop,
    message1,
    message2,
    userRestartProgress,
    timeOver,
    maxTime,
  } = props
  const [timeLeft, setTimeLeft] = useState<number>(maxTime)
  const [isProgressLine, setIsProgressLine] = useState(false)
  const timerId = useRef(0)

  const restartTimer = useCallback(() => {
    timerId.current && clearInterval(timerId.current)
    setTimeLeft(maxTime)
    
    timerId.current = setInterval(() => {
      setTimeLeft((currentValue) => {
        return currentValue < MIN_TIME ? maxTime : currentValue - MIN_TIME
      })
    }, ONE_SECOND)
  }, [])

  const restartProgressLine = useCallback(() => {
    setIsProgressLine(false)
    setTimeout(() => setIsProgressLine(true), 10)
  }, [setIsProgressLine])

  const restartProgressBar = useCallback(() => {
    if (!userStop) {
      restartTimer()
      restartProgressLine()
    }
    userRestartProgress()
  }, [restartTimer, restartProgressLine, userRestartProgress, userStop])

  useEffect(() => {
    restartProgressBar()

    return () => {
      timerId.current && clearInterval(timerId.current)
    }
  }, [restartProgressBar])

  useEffect(() => {
    if (userStop) {
      setIsProgressLine(false)
      timerId.current && clearInterval(timerId.current)
    }
  }, [userStop])

  useEffect(() => {
    if (userRestart) {
      restartProgressBar()
    }
  }, [userRestart])

  useEffect(() => {
    if(timeLeft < MIN_TIME) {
      timeOver()
      restartProgressBar()
    }
  }, [timeLeft])

  const styleProgress: CSSProperties = useMemo(() => ({
    animationDuration: `${maxTime}s`,
  }), [maxTime]);

  console.log('*** ProgressBar: ', {isProgressLine, userStop, userRestart})
  return (
    <div className={styles.wrap}>
      <div className={isProgressLine ? styles.progress : ''} style={styleProgress}></div>
      <div className={styles.message}>{message1} {timeLeft} {message2}</div>
    </div>
  )
}
